import { render, staticRenderFns } from "./GoogleCampaignDetails.vue?vue&type=template&id=6c74a2ba"
import script from "./GoogleCampaignDetails.vue?vue&type=script&lang=ts"
export * from "./GoogleCampaignDetails.vue?vue&type=script&lang=ts"
import style0 from "./GoogleCampaignDetails.vue?vue&type=style&index=0&id=6c74a2ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports